import __request__ from "routing/request";
export function getAll() {
  return __request__("GET", "/system/codecs/types/all", null, {}, {
    "Accept": ["application/json"]
  });
}
